"use strict";

exports.__esModule = true;
exports.Column = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Column = /*#__PURE__*/function () {
  function Column(idx, width, left, cubedHeight, infoWidth) {
    this.idx = idx;
    this.groups = [];
    this.height = 0;
    this.width = width;
    this.left = left;
    this.cubedHeight = cubedHeight;
    this.infoWidth = infoWidth || 0;
  }

  var _proto = Column.prototype;

  _proto.addGroup = function addGroup(group) {
    this.addGroups([group]);
  };

  _proto.addGroups = function addGroups(groups) {
    var _this = this;

    this.groups = this.groups.concat(groups);
    groups.forEach(function (group) {
      group.columnIdx = _this.idx;
      group.Column = _this;
    });
  };

  _createClass(Column, [{
    key: "totalWidth",
    get: function get() {
      return this.width + this.infoWidth;
    }
  }, {
    key: "scheme",
    get: function get() {
      return {
        idx: this.idx,
        groups: this.groups.map(function (group) {
          return group.scheme;
        }),
        width: this.width,
        height: this.height
      };
    }
  }]);

  return Column;
}();

exports.Column = Column;